import * as Types from './types';

export const openSignupModal = () => ({
  type: Types.OPEN_SIGNUP_MODAL
});

export const closeSignupModal = () => ({
  type: Types.CLOSE_SIGNUP_MODAL
});
